import React from "react"

import { iPageContext } from "../../../types"
import { ContentSeparator } from "../../Utils/ContentSeparator"
import NextArticle from "../Next/Index"
import PrevArticle from "../Previous/Index"
import RelatedArticle from "../RelatedArticles"
import RelatedVideos from "./RelatedVideos"
import UsefulLinks from "./UsefulLinks"

const ArticleRelatedContentPanel: React.FC<{
  pageContext: iPageContext
}> = ({ pageContext }) => {
  const { related_videos, useful_links } = pageContext.data
  const { related_articles, next_articles, previous_articles } = pageContext

  return (
    <>
      {(Boolean(related_videos && related_videos.length) ||
        Boolean(useful_links && useful_links.length) ||
        Boolean(related_articles && related_articles.length)) && (
        <>
          <ContentSeparator />
          <div className=" flex">
            <div
              className="rounded-full bg-site-blue-dark"
              style={{ width: "100px", height: "3px" }}
            />
          </div>
          <ContentSeparator />
          <ContentSeparator />
        </>
      )}
      {(Boolean(related_videos && related_videos.length) ||
        Boolean(useful_links && useful_links.length)) && (
        <div className="block xl:hidden">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <UsefulLinks links={useful_links} />
            <RelatedVideos links={related_videos} />
          </div>
          <ContentSeparator />
          <ContentSeparator />
        </div>
      )}

      <div>
        <RelatedArticle
          data={related_articles
            .filter((item: any) => Boolean(item))
            .map(({ node, link_prefix }: any, index: number) => ({
              id: index,
              title: node.title,
              slug: node.slug,
              introduction: node.description,
              thumbnail: node.thumbnail,
              link: `/${link_prefix}/${node.slug}`,
            }))}
        />
      </div>
      <div className="flex flex-column justify-center">
        {previous_articles && previous_articles.length ? (
          <PrevArticle items={previous_articles} />
        ) : null}
        {next_articles && next_articles.length ? (
          <NextArticle items={next_articles} />
        ) : null}
      </div>
    </>
  )
}

export default ArticleRelatedContentPanel
